export default __webpack_public_path__ + "static/media/Visual_joil_09.51326dd0.jpg";